module.exports = __webpack_public_path__ + "static/images/styles/images/nations/italy-cn.271831f8.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/italy-cn.png
// module id = 3665
// module chunks = 11